var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useMemo, useId } from 'react';
import { FormControl, FormHelperText, FormLabel, IconButton, InputAdornment, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { Visibility, VisibilityOff } from '@mui/icons-material';
/**
 *
 * @param name Định nghĩa name cho field khi sử dụng react-hook-form
 *
 * @param label Định nghĩa label cho field
 *
 * @param labelProps Định nghĩa các props cho label
 *
 * @returns
 */
var BaseTextFieldForm = function (props) {
    var id = props.id, name = props.name, label = props.label, _a = props.type, type = _a === void 0 ? 'text' : _a, labelProps = props.labelProps, callBackValidate = props.callBackValidate, required = props.required, textfieldProps = __rest(props, ["id", "name", "label", "type", "labelProps", "callBackValidate", "required"]);
    var generateId = useId();
    var idTextField = id !== null && id !== void 0 ? id : generateId;
    var _b = useState(false), isShowPassword = _b[0], setIsShowPassword = _b[1];
    var methods = useFormContext();
    var typeField = useMemo(function () {
        if (type === 'password' && isShowPassword) {
            return 'text';
        }
        return type;
    }, [isShowPassword, type]);
    var handleClickShowPassword = function () {
        setIsShowPassword(function (prev) { return !prev; });
    };
    return (_jsxs(FormControl, { fullWidth: true, children: [label && (_jsxs(FormLabel, __assign({ htmlFor: idTextField }, labelProps, { children: [label, " ", _jsx("span", { style: { color: 'red' }, children: required ? '*' : '' })] }))), _jsx(Controller, { name: name, control: methods.control, defaultValue: '', render: function (_a) {
                    var _b, _c;
                    var field = _a.field, error = _a.fieldState.error;
                    var handleChangeValue = function (e) {
                        var val = e.target.value;
                        if (callBackValidate) {
                            if (!callBackValidate(val))
                                return;
                            field.onChange(val);
                            return;
                        }
                        field.onChange(val);
                    };
                    return (_jsxs(_Fragment, { children: [_jsx(TextField, __assign({}, field, textfieldProps, { fullWidth: true, id: idTextField, error: !!error, type: typeField, value: (_b = field.value) !== null && _b !== void 0 ? _b : '', onChange: handleChangeValue, "aria-labelledby": idTextField, InputProps: __assign({ endAdornment: type === 'password' ? (_jsx(InputAdornment, { position: 'end', children: _jsx(IconButton, { size: 'small', edge: 'end', onClick: handleClickShowPassword, onMouseDown: function (e) { return e.preventDefault(); }, children: isShowPassword ? _jsx(VisibilityOff, {}) : _jsx(Visibility, {}) }) })) : (((_c = textfieldProps === null || textfieldProps === void 0 ? void 0 : textfieldProps.InputProps) === null || _c === void 0 ? void 0 : _c.endAdornment) || null) }, ((textfieldProps === null || textfieldProps === void 0 ? void 0 : textfieldProps.InputProps) || {})) })), error && error.message && _jsx(FormHelperText, { error: true, children: error.message })] }));
                } })] }));
};
export default BaseTextFieldForm;
